import { put, call, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
// import ApiService from '../Services/ApiService';
// import AppActions from '../Stores/App/Actions';
import PrincipalProcessActions, { PrincipalProcessTypes } from '../Stores/PrincipalProcess/Actions';

// const getAppStore = state => state.app;

// eslint-disable-next-line import/prefer-default-export
export function* principalProcessFetchPrincipalProcess() {
  try {
    yield put(PrincipalProcessActions.principalProcessFetchPrincipalProcessLoading(true));

    const result = [
      { proc_type: 'PRINCIPAL_LIST_01', icon: 'fa fa-cubes' }
      // { proc_type: 'PRINCIPAL_EXCEL_01', icon: 'fa fa-file-excel-o' },
      // { proc_type: 'PRINCIPAL_SYNC_01', icon: 'fa fa-refresh' }
    ];
    yield put(PrincipalProcessActions.principalProcessFetchPrincipalProcessSuccess(result));

    /*
    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `site/indexItemFlow/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );
    
    if (result.isSuccess === true) {
      yield put(PrincipalProcessActions.principalProcessFetchPrincipalProcessSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
    */
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PrincipalProcessActions.principalProcessFetchPrincipalProcessLoading(false));
  }
}

export const saga = [
  takeLatest(
    PrincipalProcessTypes.PRINCIPAL_PROCESS_FETCH_PRINCIPAL_PROCESS,
    principalProcessFetchPrincipalProcess
  )
];
